
import zhizhen from '@/assets/woxinxiangdang/zhuanpan-zhizhen.png'
import zhizhenGray from '@/assets/woxinxiangdang/zhuanpan-zhizhen-gray.png'
import cjimg from '@/assets/qingxinvzhigong/guajiang.png'
import config from '@/config/index'
import { getintegral } from '@/api/user.js'
import { award, isAward } from '@/api/lottery'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'

import { getAddressDefault, addAddress, editAddress } from '@/api/user'
import {
addCreditParty,
relation,
view,
addPartyCount,
cutCreditPartyNum,
cutCreditParty
} from '@/api/jfhl.js'
import { getUserItem, updateuser, add } from '@/api/lottery.js'
export default {
directives: {
TransferDom
},
components: {
},
data () {
return {
baseUrl: config.baseUrl,
show: false,
context: '',
msg: '',
isaward: '',
partyid: this.$route.params.partyid,
zhongjiang: false,
prizelist: '',
lottery: true,
showtouch: true,
headerBanner:''
}
},
created () {
if (this.$route.params.obj != null) {
this.addcount() 
} else {
this.$router.push({ name: 'qingxinvzhigongIndex', params: { partyid: this.partyid } })
}


},
mounted () {
this.getview() 
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
},
top () {
return -this.activeIndex * 30 + 'px'
}
},










methods: {

























































































































isawardNow () {
isAward({
lotid: this.lotid,
openid: this.userid
}).then(data => {
if (data.obj.iszhongjiang === 1) {



this.msg = data.obj.item
this.$vux.toast.text('本次活动您已经中过奖')
this.zhongjiang = true
this.showtouch = false
this.showResult()
} else {


}
})
},

addcount () {
addPartyCount({
partyid: this.partyid,
accoutid: this.accountid,
credittype: 1
}).then(res => { })
},

addJiFen (credit) {
addCreditParty({
accoutid: this.accountid,
credit: credit,
partyid: this.partyid,
type: 1
}).then(res => { })
},















getview () {
view({
id: this.partyid
}).then(res => {
document.title = res.obj.title
this.headerBanner = res.obj.hdpicList.length > 0 && this.baseUrl + res.obj.hdpicList[0].FILEPATH
this.lotid = res.obj.lotid
this.paperInfoid = res.obj.paperid
this.startTime = res.obj.signstartdate.replace(/-/g, '/')
this.endTime = res.obj.signenddate.replace(/-/g, '/')
this.isCurrentTime(this.startTime, this.endTime)
this.getWinning()
this.init()
})
},

isCurrentTime (beginTime, endTime) {
var currentTime = new Date()
var beginTime = new Date(beginTime)
var endTime = new Date(endTime)
if (currentTime < beginTime) {
this.$vux.alert.show({
content: '抽奖活动还未开始'
})


return false
}
if (currentTime >= endTime) {
this.$vux.alert.show({
content: '抽奖活动已结束'
})


return false
}


this.isawardNow()
},

cutCredit (credit) {
cutCreditParty({
accoutid: this.accountid,
credit: credit,
partyid: this.partyid
})
},

getintegralTotal () {
getintegral({
accountid: this.accountid,
owner_type: this.owner_type,
userid: this.userid
}).then(res => {
this.integral = res.returnValue.allnow
})
},










ontab (index) {
this.selected = index
},

golottery () {
this.lottery = false
let _this = this
award({
lotid: this.lotid,
openid: this.accountid,
lotteryNum: 1
}).then(data => {
if (data.success) {
this.isaward = data.obj.isaward

if (data.obj.isaward == 2) {
this.$vux.alert.show({
content: '您已经抽过奖',
buttonText: '回到首页',
onHide () {
_this.$router.push({ name: 'qingxinvzhigongIndex', params: { id: _this.partyid } })
}
})
} else {
this.msg = data.obj.item
if (data.obj.item.indexOf('积分') != -1) {
this.addJiFen(data.obj.item.replace(/[^0-9]/gi, ''))
} else {
if (data.obj.isaward == 1) {

relation({

lotid: this.lotid,
userid: this.accountid,
openid: this.userid
}).then(data => { })
}
}
}
}
this.showResult()
})
},






















getWinning () {
getUserItem({
openid: this.accountid,
lotid: this.lotid
}).then(res => {
this.prizelist = res.obj.items
})
},














gorule () {
this.$router.push({ name: 'qingxinvzhigongRule' })
},
goback () {
console.log('test')
this.$router.push({ name: 'qingxinvzhigongIndex', params: { id: this.partyid } })
},
init () {
let canvas = document.getElementById('mask')

let _this = this
var img = new Image()
img.src = cjimg
img.onload = function () {
let context = canvas.getContext('2d')
context.drawImage(img, 0, 0, 270, 162)
context.globalCompositeOperation = 'destination-out'
_this.context = context
console.log(context)
}










canvas.addEventListener('touchstart', this.drawArcMouseHandle)
canvas.addEventListener('touchsend', event => {

this.removeEventListener('touchmove', this.mousemoveHandle)
})

canvas.addEventListener('touchmove', this.drawArcTouchHandle)
this.show = true
},

drawArcMouseHandle (event) {
event.preventDefault()
event.target.addEventListener('touchmove', this.mousemoveHandle)
},

mousemoveHandle (event) {
event.preventDefault()
this.drawArcByPoint(event.pageX, event.pageY)
},

drawArcTouchHandle (event) {
event.preventDefault()
var touch = event.touches[0]
this.drawArcByPoint(touch.pageX, touch.pageY)
},



drawArcByPoint (x, y) {
this.context.beginPath()
this.context.arc(
x - canvas.offsetLeft,
y - canvas.offsetTop,
15,
0,
Math.PI * 2
)
this.context.closePath()
this.context.fillStyle = '#ffffff'
this.context.fill()
this.checkComplete()
},

checkComplete () {
var imgData = this.context.getImageData(0, 0, 270, 162)
var pxData = imgData.data 
var len = pxData.length 
var count = 0 

for (var i = 0; i < len; i += 4) {
var alpha = pxData[i + 3] 
if (alpha < 10) {

count++
}
}
var percent = count / (len / 4) 

if (percent > 0.5) {
if (this.lottery) {
this.golottery()
}
}
if (percent >= 0.6) {
}
},

showResult () {
this.context.clearRect(0, 0, 270, 162)
if (this.isaward === 1) {
this.zhongjiang = true
}
},
setZhongjiang (val) {
this.zhongjiang = val
}
}
}
